// extracted by mini-css-extract-plugin
export default {"tableWrapper":"table_tableWrapper__qKzqK","commonStylingForHeader":"table_commonStylingForHeader__W9UYb","commonTableContainer":"table_commonTableContainer__Zmzh8"};